module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sally Keith\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Sally Keith")]), _vm._v(" is the author of three previous collections of poetry. Her first, "), _c('I', [_vm._v("Design")]), _vm._v(" was the winner of the 2000 Colorado Prize selected by Allen Grossman. In 2004, "), _c('I', [_vm._v("Dwelling Son")]), _vm._v(" was selected by Fanny Howe for the Contemporary Poetry Series. Most recently she released "), _c('I', [_vm._v("The Fact of the Matter")]), _vm._v(". A graduate of the Iowa Writer’s Workshop and winner of numerous awards and fellowships, Keith is currently a member of the MFA Faculty at George Mason University and lives in Washington, D.C.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AINZpd/tc-custom/9781571319111.jpg?1705259591391",
      "alt": "This image is the cover for the book River House"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("River House\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“This heartbreaking and robust poetry collection . . . explores the complexity of the mind in the midst of grief” ("), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(", starred review).")]), _c('br'), _c('br'), _vm._v("These are poems of absence. Written in the wake of the loss of her mother, "), _c('i', [_vm._v("River House")]), _vm._v(" follows Sally Keith as she makes her way through the depths of grief, navigating a world newly transfigured."), _c('br'), _c('br'), _vm._v("Incorporating her travels abroad, her experience studying the neutral mask technique developed by Jacques Lecoq, and her return to the river house she and her mother often visited, the poet assembles a guide to survival in the face of seemingly insurmountable pain. Even in the dark, Keith finds the ways we can be “filled with this unexpected feeling of living.”\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Milkweed Editions\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0